import { h } from 'preact';

import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { UserRegistrationTemplateRefactored } from 'common/module/user/registration/template-refactored';
import { UserRegistrationViewStoreFactory } from 'common/module/user/registration/view-store.factory';

const Component = preactDynamicComponent(UserRegistrationTemplateRefactored);
const store = UserRegistrationViewStoreFactory();
store.initialize();

export const UserRegistrationComponent = () => <Component viewStore={store} />;
